import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { GCADAConfirmDialogComponent } from '@GCADA/components/confirm-dialog/confirm-dialog.component';

@NgModule({
    declarations: [
        GCADAConfirmDialogComponent
    ],
    imports: [
        MatDialogModule,
        MatButtonModule
    ],
    entryComponents: [
        GCADAConfirmDialogComponent
    ],
})
export class GCADAConfirmDialogModule
{
}
